<template>
  <div>
    <p>
      <span class="modal-body-text"
        >You are about to delete path {{ data.name }} from level.</span
      ><br /><br />
      <span class="modal-body-text">Are you sure you want to continue?</span>
      <br />
    </p>
  </div>
</template>

<script>
export default {
  name: "delete-level-path-modal",
  props: {
    data: null
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal/ConfirmDeletionLevelPath.vue